import { createContext } from 'react';
const ds = {};
const Store = createContext({
    dataSet: ds,
    queryDataSet: ds,
    menuDataSet: ds,
    filterMenuDataSet: ds,
    conditionDataSet: ds,
    optionDataSet: ds,
    shouldLocateData: false,
});
export default Store;
